<template>
    <Modal size="sm" @close="close">
        <div class="text-center text-sm">
            <div>
                <slot v-bind="{ close, stop, start, ambassadorship }"></slot>
            </div>
        </div>
    </Modal>
</template>

<script type="text/babel">
import Modal from 'dashboard-js/components/Modal'

export default {
    components: { Modal },

    props: ['ambassadorship'],

    methods: {
        close() {
            this.$emit('close')
        },

        start() {
            axios.post(route('api.ambassadorship.start', this.ambassadorship.id)).then(response => {
                this.$emit('updated', response.data)
                this.close()
            })
        },

        stop() {
            axios.post(route('api.ambassadorship.stop', this.ambassadorship.id)).then(response => {
                this.$emit('updated', response.data)
                this.close()
            })
        },
    },
}
</script>
